export const dateString = (date, short) =>
  new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: short ? "short" : "long",
    day: "2-digit",
  }).format(new Date(date.includes("T") ? date : `${date}T00:00:00.000`))

export const dateTimeString = (date) =>
  new Intl.DateTimeFormat("en-US", {
    dateStyle: "long",
    timeStyle: "short",
    timeZone: process.env.GATSBY_DEFAULT_TIMEZONE,
  }).format(new Date(date))

const baseRules = (rules, objectMapping) =>
  rules.map((block) => {
    const newBlock = block
    newBlock.children = block.children.map((subBlock) => {
      const newSubBlock = subBlock
      newSubBlock.text = subBlock.text.replace(
        /\${([^}]+)}/g,
        (_, prop) => objectMapping[prop]
      )
      return newSubBlock
    })
    return newBlock
  })

export default baseRules
